module.exports = __webpack_public_path__ + "public/images/search.645e4cf4dd45eeaf2215345f62f03082.svg";